"use client"

import { HttpTypes } from "@medusajs/types"
import { captureAnalyticsEvent } from "@/lib/analytics/posthog-client"
import { ExpressCartProvider } from "../providers/express-cart"
import ExpressRouter from "../components/router"
import LocalizedClientLink from "@/modules/common/components/localized-client-link"
import { ArrowLeftMini } from "@medusajs/icons"
import { useEffect, useRef } from "react"

type ExpressCheckoutTemplateProps = {
  product: HttpTypes.StoreProduct
  region: HttpTypes.StoreRegion
  countryCode: string
  initialCart?: HttpTypes.StoreCart | null
}

/**
 * Express Checkout Template
 * Main wrapper for the express checkout flow
 */
const ExpressCheckoutTemplate = ({
  product,
  region,
  countryCode,
  initialCart,
}: ExpressCheckoutTemplateProps) => {
  const hasFiredCheckoutStarted = useRef(false)
  useEffect(() => {
    if (hasFiredCheckoutStarted.current) return
    hasFiredCheckoutStarted.current = true
    captureAnalyticsEvent("checkout_started", {
      entry_point: initialCart?.items?.length ? "cart" : "product_page",
      product_id: product.id,
      product_title: product.title,
    })
  }, [initialCart?.items?.length, product.id, product.title])

  return (
    <ExpressCartProvider initialCart={initialCart}>
      <div className="min-h-screen bg-neutral-50">
        {/* Header */}
        <div className="bg-white border-b border-neutral-200 sticky top-0 z-10">
          <div className="content-container px-4 md:px-6 lg:px-8 py-4">
            <div className="flex items-center justify-between">
              <LocalizedClientLink
                href={`/products/${product.handle}`}
                className="flex items-center gap-2 text-sm text-neutral-600 hover:text-neutral-900 transition-colors"
              >
                <ArrowLeftMini className="w-4 h-4" />
                <span>Nazaj na izdelek</span>
              </LocalizedClientLink>
              <h1 className="text-lg font-semibold">Hiter nakup</h1>
              <div className="w-24" /> {/* Spacer for centering */}
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="content-container px-4 md:px-6 lg:px-8 py-8">
          <ExpressRouter
            product={product}
            region={region}
            countryCode={countryCode}
          />
        </div>

        {/* Footer Note */}
        <div className="content-container px-4 md:px-6 lg:px-8 py-4 text-center">
          <p className="text-sm text-neutral-500">
            Varno plačilo • Hitra dostava • Enostaven nakup
          </p>
        </div>
      </div>
    </ExpressCartProvider>
  )
}

export default ExpressCheckoutTemplate






